import {
    View
} from "react-native";
import type ThreeTTablesProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";

const Tables = ({
    participants,
    tables
}: ThreeTTablesProps) => {
    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const {
        radiuses,
        borders,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const renderParticipants = (participantList: string[]) => {
        return participantList.map(userId => {
            const participant = participants.find(p => p.id === userId);
            if (!participant) return null;

            const participantFullName = participant.userInfo?.name ? `${participant.userInfo.name} ${participant.userInfo.surname || ""}`.trim() : participant.name;

            return <View
                style={[
                    stylesheet.participantBox,
                    {
                        backgroundColor: colors.content.border.subtle,
                        padding: spaces.spacingMd,
                        borderRadius: radiuses.md
                    }
                ]}
                key={userId}
            >
                <Text
                    style={stylesheet.participantText}
                    variant="bodyMediumSize"
                    color="high"
                >
                    {participantFullName}
                </Text>
            </View>;
        });
    };

    return <View
        style={[
            stylesheet.container,
            {
                gap: spaces.spacingXl
            }
        ]}
    >
        {tables.map((tableParticipantIds, index) => {
            const partic: { bottom: string[], right: string[], left: string[], top: string[] } = {
                bottom: [],
                right: [],
                left: [],
                top: []
            };

            tableParticipantIds.forEach((p, idx) => {
                switch (idx % 4) {
                    case 0:
                        partic.top.push(p);
                        break;
                    case 1:
                        partic.bottom.push(p);
                        break;
                    case 2:
                        partic.left.push(p);
                        break;
                    case 3:
                        partic.right.push(p);
                        break;
                    default:
                        partic.top.push(p);
                        break;
                }
            });

            return <View
                style={[
                    stylesheet.tableContainer,
                    {
                        backgroundColor: colors.project.brandWhite,
                        borderColor: colors.content.border.subtle,
                        borderWidth: borders.seperator,
                        borderRadius: radiuses.md,
                        padding: spaces.spacingLg,
                        gap: spaces.spacingMd
                    }
                ]}
                key={`table-${index}`}
            >
                <View
                    style={[
                        stylesheet.tableHeader,
                        {
                            borderBottomColor: colors.content.border.subtle,
                            borderBottomWidth: borders.seperator,
                            paddingBottom: spaces.spacingMd,
                            marginBottom: spaces.spacingMd
                        }
                    ]}
                >
                    <Text
                        variant="bodyMediumSize"
                        color="high"
                    >
                        {localize("threet-table")} {index + 1}
                    </Text>
                    <Text
                        variant="bodySmallSize"
                        color="mid"
                    >
                        {tableParticipantIds.length} {localize("threet-people")}
                    </Text>
                </View>
                <View>
                    <View
                        style={[
                            stylesheet.top,
                            {
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        {renderParticipants(partic.top)}
                    </View>
                    <View
                        style={stylesheet.tableHorizontalContainer}
                    >
                        <View
                            style={[
                                stylesheet.left,
                                {
                                    gap: spaces.spacingSm
                                }
                            ]}
                        >
                            {renderParticipants(partic.left)}
                        </View>
                        <View
                            style={[
                                stylesheet.tableCenter,
                                {
                                    backgroundColor: colors.content.border.emphasized,
                                    borderRadius: radiuses.xl,
                                    margin: spaces.spacingLg
                                }
                            ]}
                        >
                            <Text
                                customColor={colors.project.brandWhite}
                                variant="displayMediumSize"
                            >
                                {index + 1}
                            </Text>
                        </View>
                        <View
                            style={[
                                stylesheet.right,
                                {
                                    gap: spaces.spacingSm
                                }
                            ]}
                        >
                            {renderParticipants(partic.right)}
                        </View>
                    </View>
                    <View
                        style={[
                            stylesheet.bottom,
                            {
                                gap: spaces.spacingSm
                            }
                        ]}
                    >
                        {renderParticipants(partic.bottom)}
                    </View>
                </View>
            </View>;
        })}
    </View>;
};

export default Tables;
